<template>
  <div class="developer-user">
    <div class="search-wrap">
<!--      <el-input v-model="where.address" placeholder="请输入房间号或地址"></el-input>-->
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
    </div>
    <HeaderTip>
      开发商数量：{{ pageData.total }}
    </HeaderTip>
    <el-table :loading="loading" :data="pageData.data" :border="true" height="70vh" style="width: 100%">
      <el-table-column prop="id" label="id" width="90" fixed="left"></el-table-column>
      <el-table-column prop="name" label="名字" min-width="200" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" @click="openCustomer(scope.row)">{{scope.row.name}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="class" label="房间类型" width="100">
        <template slot-scope="scope">
          {{scope.row.class===1?"个人":"企业"}}
        </template>
      </el-table-column>
      <el-table-column prop="credentials_code" label="证件号码" width="200"></el-table-column>
      <el-table-column prop="contact_number" label="联系电话" width="100"></el-table-column>
      <el-table-column prop="house_list" label="关联房产数量" width="100">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title=""
            width="400"
            trigger="click">
            <template slot="default">
              <div style="max-height: 500px; overflow-y: scroll;">
              <span v-for="(item2,idx) in scope.row.house_list" :key="idx">
                {{item2.ancestor_name}} （{{item2.status_name}}）<br />
              </span>
              </div>
            </template>
            <el-link type="primary" slot="reference">{{scope.row.house_list.length}}</el-link>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="order" label="关联账单数量" width="100">
        <template slot-scope="scope">
          {{scope.row.order_count}} / {{scope.row.all_order_count}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" @click="openCustomer(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total" :page-size="pageData.per_page" :current-page="pageData.current_page" @current-change="pageChange"></el-pagination>
    </div>
    <editor v-model="customerObj.isOpen" :id="customerObj.id" :is_edit="customerObj.is_edit" :class-value="customerObj.classValue" @close="customerObj.isOpen=false" :type_arr="[5]" />
  </div>
</template>

<script>
import Http from "../../../Customer/common/Http";
import Editor from "../../../Customer/editor";
import HeaderTip from "../../../Common/header-tip";

export default {
  name: "DeveloperUser",
  components: {HeaderTip, Editor},
  inject: ['mainObj'],
  data(){
    return{
      loading: false,
      where:{
        project_id:0,
        address:""
      },
      pageData:{
        list:[],
        total:0,
        per_page:15,
        current_page:1
      },
      customerObj:{isOpen:false,id:0,classValue:0,is_edit:true}
    }
  },
  mounted(){
    this.where.project_id=this.mainObj.project_id;
    this.getList();
  },
  methods:{
    openCustomer(row){
      this.customerObj.isOpen=true;
      this.customerObj.id=row.id;
      this.customerObj.classValue=row.class;
      this.customerObj.is_edit=true;
    },
    getList(){
      const that=this;
      that.loading=true;
      Http.post("/admin/DeveloperUser/getDeveloperUserList", {
        ...that.where,
        page:that.pageData.current_page,
        per_page:that.pageData.per_page
      }, ret => {
        that.loading=false;
        if(ret.code){
          that.pageData=ret.data;
        }
      });
    },
    search(){
      this.pageChange(1);
    },
    pageChange(page){
      this.pageData.page=page;
      this.getList();
    }
  },
  watch:{
    "mainObj.project_id":function(val){
      this.where.project_id=val;
      this.search();
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
.developer-user{

  .pagination-wrap{
    margin-top: 20px;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/HouseCode/components/room-status/DeveloperUser.vue